import { useEffect, useState } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import {
  BlockServiceReasonAction,
  SalonAvailabilityDetailAction,
  SalonAvailabilityStaffUpdateAction,
  SalonAvailabilityUpdateAction,
} from "../../../../redux/Action/Availability";
import Button from "../../../../components/Ui/Button";
import Spinner from "../../../../components/Spinner";
import BlockService from "./BlockService";
import { FormattedMessage } from "react-intl";
import {
  localFormToUtcDateAndTime,
  sidebarOpen,
  UTCFormat,
  utcStoredToLocalDateAndTime,
  WEEKDAY_UTC_ANCHOR,
} from "../../../../utils/Helper";

const isValidPickerDate = (value: any) =>
  value instanceof Date && !Number.isNaN(value.getTime());

const StaffAvailability = () => {
  const local_language = localStorage.getItem("lang");
  const [data, setData] = useState(null);

  const dispatch = useDispatch<any>();
  const [calendarError, setCalendarError] = useState("");
  const salon_detail = useSelector(
    (state: any) => state.SalonAvailabilityState,
  );
  const profile_data = useSelector((state: any) => state.GetProfileState);
  const salon_availability_update = useSelector(
    (state: any) => state.StaffAvailabilityUpdateState,
  );

  const daysOfWeekAlbenia = {
    en: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ],
    alb: [
      "E hënë",
      "E martë",
      "E mërkurë",
      "E enjte",
      "E premte",
      "E shtunë",
      "E diel",
    ],
  };
  const albanianToEnglishDaysMap: any = {
    "E hënë": "Monday",
    "E martë": "Tuesday",
    "E mërkurë": "Wednesday",
    "E enjte": "Thursday",
    "E premte": "Friday",
    "E shtunë": "Saturday",
    "E diel": "Sunday",
  };

  const [calendar, setCalendar] = useState([
    {
      day: daysOfWeekAlbenia.alb[0],
      start_time: "",
      end_time: "",
      is_day_off: false,
      error: { start_time: "", end_time: "" },
    },
    {
      day: daysOfWeekAlbenia.alb[1],
      start_time: "",
      end_time: "",
      is_day_off: false,
      error: { start_time: "", end_time: "" },
    },
    {
      day: daysOfWeekAlbenia.alb[2],
      start_time: "",
      end_time: "",
      is_day_off: false,
      error: { start_time: "", end_time: "" },
    },
    {
      day: daysOfWeekAlbenia.alb[3],
      start_time: "",
      end_time: "",
      is_day_off: false,
      error: { start_time: "", end_time: "" },
    },
    {
      day: daysOfWeekAlbenia.alb[4],
      start_time: "",
      end_time: "",
      is_day_off: false,
      error: { start_time: "", end_time: "" },
    },
    {
      day: daysOfWeekAlbenia.alb[5],
      start_time: "",
      end_time: "",
      is_day_off: false,
      error: { start_time: "", end_time: "" },
    },
    {
      day: daysOfWeekAlbenia.alb[6],
      start_time: "",
      end_time: "",
      is_day_off: false,
      error: { start_time: "", end_time: "" },
    },
  ]);

  // Handle checkbox change
  const handleCheckboxChange = (
    index: any,
    start: any,
    end: any,
    error: any,
  ) => {
    const updatedCalendar = [...calendar];
    updatedCalendar[index].is_day_off = !updatedCalendar[index].is_day_off;

    if (!updatedCalendar[index].is_day_off) {
      updatedCalendar[index].start_time = "";
      updatedCalendar[index].end_time = "";
      updatedCalendar[index].error = { start_time: "", end_time: "" };
    } else {
      if (!updatedCalendar[index].start_time) {
        updatedCalendar[index].error.start_time =
          local_language == "alb"
            ? "Ju lutemi shkruani orën e fillimit."
            : "Please enter start time";
      }
      if (!updatedCalendar[index].end_time) {
        updatedCalendar[index].error.end_time =
          local_language == "alb"
            ? "Ju lutemi shkruani orën e përfundimit"
            : "Please enter end time";
      }
    }

    setCalendar(updatedCalendar);
  };

  // Handle input field change
  const handleInputFieldChange = (index: any, field: any, value: any) => {
    const updatedCalendar: any = [...calendar];
    updatedCalendar[index][field] = value;

    if (updatedCalendar[index].is_day_off) {
      if (field === "start_time" && value) {
        updatedCalendar[index].error.start_time = "";
      } else if (field === "end_time" && value) {
        updatedCalendar[index].error.end_time = "";
      }
    }

    if (!updatedCalendar[index].is_day_off) {
      if (
        (field === "start_time" && value) ||
        (field === "end_time" && value)
      ) {
        updatedCalendar[index].is_day_off = true;
      }
    }

    if (updatedCalendar[index].is_day_off) {
      if (field === "start_time" && !value) {
        updatedCalendar[index].error.start_time =
          local_language == "alb"
            ? "Ju lutemi shkruani orën e fillimit."
            : "Please enter start time";
      } else if (field === "end_time" && !value) {
        updatedCalendar[index].error.end_time =
          local_language == "alb"
            ? "Ju lutemi shkruani orën e përfundimit"
            : "Please enter end time";
      }
    }

    if (
      field === "start_time" &&
      updatedCalendar[index]["end_time"] &&
      value >= updatedCalendar[index]["end_time"]
    ) {
      updatedCalendar[index].error.start_time =
        local_language == "alb"
          ? "Koha e fillimit duhet të jetë më e hershme se koha e përfundimit"
          : "Start time must be earlier than end time";
    } else if (
      field === "end_time" &&
      updatedCalendar[index]["start_time"] &&
      value <= updatedCalendar[index]["start_time"]
    ) {
      updatedCalendar[index].error.end_time =
        local_language == "alb"
          ? "Koha e përfundimit duhet të jetë më vonë se ora e fillimit"
          : "End time must be later than start time";
    } else {
      updatedCalendar[index].error.start_time = "";
      updatedCalendar[index].error.end_time = "";
    }

    if (
      (field === "start_time" || field === "end_time") &&
      updatedCalendar[index]["start_time"] &&
      updatedCalendar[index]["end_time"]
    ) {
      const startTime = moment(updatedCalendar[index]["start_time"], "HH:mm");
      const endTime = moment(updatedCalendar[index]["end_time"], "HH:mm");

      if (!startTime.isValid()) {
        updatedCalendar[index].error.start_time = "Please select start time";
      } else if (!endTime.isValid()) {
        updatedCalendar[index].error.end_time = "Please select end time";
      } else {
        const duration = moment.duration(endTime.diff(startTime));
        if (duration.asHours() < 2) {
          updatedCalendar[index].error.end_time =
            local_language == "alb"
              ? "Duhet të ketë të paktën 2 orë ndërmjet kohës së fillimit dhe përfundimit"
              : "There must be at least 2 hours between start and end times";
        } else {
          updatedCalendar[index].error.end_time = "";
        }
      }
    }

    // Additional checks to ensure both times are provided
    if (field === "start_time" && !updatedCalendar[index]["end_time"]) {
      updatedCalendar[index].error.end_time =
        local_language == "alb"
          ? "Ju lutemi shkruani orën e përfundimit"
          : "Please enter end time";
    } else if (field === "end_time" && !updatedCalendar[index]["start_time"]) {
      updatedCalendar[index].error.start_time =
        local_language == "alb"
          ? "Ju lutemi shkruani orën e fillimit."
          : "Please enter start time";
    }

    setCalendar(updatedCalendar);
  };

  const validateCalendar = () => {
    const updatedCalendar = [...calendar];
    let hasError = false;
    updatedCalendar.forEach((day, index) => {
      // Only validate when the day is selected (is_day_off is false)
      if (day?.is_day_off == true) {
        if (!day.start_time) {
          updatedCalendar[index].error.start_time =
            local_language == "alb"
              ? "Ju lutemi shkruani orën e fillimit."
              : "Please enter start time";
          hasError = true;
        }
        if (!day.end_time) {
          updatedCalendar[index].error.end_time =
            local_language == "alb"
              ? "Ju lutemi shkruani orën e përfundimit"
              : "Please enter end time";
          hasError = true;
        }

        if (day.start_time && day.end_time) {
          const startTime = moment(day.start_time, "HH:mm");
          const endTime = moment(day.end_time, "HH:mm");

          if (!startTime.isValid()) {
            updatedCalendar[index].error.start_time =
              "Please select start time";
            hasError = true;
          }
          if (!endTime.isValid()) {
            updatedCalendar[index].error.end_time = "Please select end time";
            hasError = true;
          }
          if (startTime.isValid() && endTime.isValid()) {
            const duration = moment.duration(endTime.diff(startTime));
            if (duration.asHours() < 2) {
              updatedCalendar[index].error.end_time =
                "There must be at least 2 hours between start and end times";
              hasError = true;
            }
          }
        }

        if (day.start_time && day.end_time && day.start_time >= day.end_time) {
          updatedCalendar[index].error.start_time =
            local_language == "alb"
              ? "Koha e fillimit duhet të jetë më e hershme se koha e përfundimit"
              : "Start time must be earlier than end time";
          hasError = true;
        }
        if (day.end_time && day.start_time && day.end_time <= day.start_time) {
          updatedCalendar[index].error.end_time =
            local_language == "alb"
              ? "Koha e përfundimit duhet të jetë më vonë se ora e fillimit"
              : "End time must be later than start time";
          hasError = true;
        }

        if (!day.start_time && day.end_time) {
          updatedCalendar[index].error.start_time =
            local_language == "alb"
              ? "Ju lutemi shkruani orën e fillimit."
              : "Please enter start time";
          hasError = true;
        }
        if (!day.end_time && day.start_time) {
          updatedCalendar[index].error.end_time =
            local_language == "alb"
              ? "Ju lutemi shkruani orën e përfundimit"
              : "Please enter end time";
          hasError = true;
        }
      }
    });

    setCalendar(updatedCalendar);
    return !hasError;
  };

  const handleToClickAll = () => {
    const commonTime = calendar.find((day) => day.start_time && day.end_time);
    if (commonTime) {
      const { start_time, end_time } = commonTime;
      setCalendar(
        calendar.map((day) => ({
          ...day,
          start_time,
          end_time,
          is_day_off: true,
          error: { start_time: "", end_time: "" },
        })),
      );
    }
  };

  useEffect(() => {
    const formatTimes = () => {
      const formattedCalendar: any = calendar.map((day) => {
        const englishDay = albanianToEnglishDaysMap[day.day];
        const anchor = englishDay ? WEEKDAY_UTC_ANCHOR[englishDay] : null;

        let start_time = "";
        let end_time = "";
        if (day.start_time && anchor) {
          const s = localFormToUtcDateAndTime(anchor, day.start_time);
          if (s) start_time = s.time;
        }
        if (day.end_time && anchor) {
          const e = localFormToUtcDateAndTime(anchor, day.end_time);
          if (e) end_time = e.time;
        }
        // Fallback keeps prior UTCFormat behavior if anchor conversion fails
        if (!start_time && day.start_time) {
          start_time = UTCFormat(day.start_time) ?? "";
        }
        if (!end_time && day.end_time) {
          end_time = UTCFormat(day.end_time) ?? "";
        }

        return {
          ...day,
          day: englishDay,
          start_time,
          end_time,
        };
      });
      setData(formattedCalendar);
    };
    formatTimes();
  }, [calendar]);

  const handleSubmitData = (e: any) => {
    e.preventDefault();
    if (!validateCalendar()) {
      return;
    }

    const isValid = calendar.some(
      (day) => day.is_day_off && day.start_time && day.end_time,
    );
    if (!isValid) {
      setCalendarError(
        local_language == "alb"
          ? "Ju lutemi zgjidhni të paktën një orë pune të sallonit."
          : "Please select at least one operational hours of salon.",
      );
      return;
    }

    const isError = calendar.some(
      (day) => day?.error?.start_time != "" || day?.error?.end_time != "",
    );
    if (isError) {
      return;
    }

    const payload: any = {
      parent_id: profile_data?.data?.data?.id,
      opt_days: data,
      // avg_scale: 1
    };

    dispatch(SalonAvailabilityStaffUpdateAction(payload));
  };

  // useEffect(() => {
  //     if (salon_availability_update?.status) {
  //         dispatch(SalonAvailabilityDetailAction({ detail_id: profile_data?.data?.data?.id }))
  //     }
  // }, [salon_availability_update])

  useEffect(() => {
    dispatch(
      SalonAvailabilityDetailAction({
        detail_id: profile_data?.data?.data?.id,
      }),
    );
  }, []);

  useEffect(() => {
    if (salon_detail?.status) {
      if (salon_detail?.data?.data) {
        const updatedCalendar: any = calendar.map((day) => {
          const matchingProfileDay = salon_detail?.data?.data?.find(
            (profileDay: any) =>
              albanianToEnglishDaysMap[day.day] == profileDay.day,
          );

          if (matchingProfileDay) {
            const local_start_time =
              matchingProfileDay.start_time != "00:00:00" &&
              matchingProfileDay.start_time;
            const local_end_time =
              matchingProfileDay.end_time != "00:00:00" &&
              matchingProfileDay.end_time;

            const originalStartTime =
              local_start_time && local_start_time.length > 0
                ? local_start_time
                : "";
            const originalEndTime =
              local_end_time && local_end_time.length > 0 ? local_end_time : "";

            // Prefer explicit UTC→local parse (Safari-safe; no Date.toString round-trip)
            const anchor =
              WEEKDAY_UTC_ANCHOR[matchingProfileDay.day as string] || null;
            const startUtcPair =
              anchor && originalStartTime
                ? utcStoredToLocalDateAndTime(anchor, String(originalStartTime))
                : null;
            const endUtcPair =
              anchor && originalEndTime
                ? utcStoredToLocalDateAndTime(anchor, String(originalEndTime))
                : null;

            if (
              startUtcPair &&
              endUtcPair &&
              isValidPickerDate(startUtcPair.timeDate) &&
              isValidPickerDate(endUtcPair.timeDate)
            ) {
              return {
                ...day,
                is_day_off: matchingProfileDay?.is_day_off ? true : false,
                start_time: startUtcPair.timeDate,
                end_time: endUtcPair.timeDate,
              };
            }

            // Fallback: build Date from HH:mm[:ss] without browser string parsing
            if (originalStartTime && originalEndTime) {
              const startM = moment(
                String(originalStartTime),
                ["HH:mm:ss", "HH:mm"],
                true,
              );
              const endM = moment(
                String(originalEndTime),
                ["HH:mm:ss", "HH:mm"],
                true,
              );
              if (startM.isValid() && endM.isValid()) {
                const startDate = moment()
                  .hours(startM.hours())
                  .minutes(startM.minutes())
                  .seconds(startM.seconds())
                  .milliseconds(0)
                  .toDate();
                const endDate = moment()
                  .hours(endM.hours())
                  .minutes(endM.minutes())
                  .seconds(endM.seconds())
                  .milliseconds(0)
                  .toDate();
                return {
                  ...day,
                  is_day_off: matchingProfileDay?.is_day_off ? true : false,
                  start_time: startDate,
                  end_time: endDate,
                };
              }
            }
          }

          return day;
        });
        setCalendar(updatedCalendar);
      }
    }
  }, [salon_detail]);

  // useEffect(() => {
  //     dispatch(BlockServiceReasonAction({}))
  // }, []);

  return (
    <>
      <div className="col-lg-9 addNewService">
        {salon_detail?.loading ? <Spinner /> : ""}
        <div className="dashboard bg-white">
          <div className="dashboardTop">
            <h2>
              <button
                type="button"
                onClick={() => {
                  sidebarOpen();
                }}
                className="btn mobileMenu p-1 d-lg-none"
              >
                <span className="icon-menu-right"></span>
              </button>{" "}
              <FormattedMessage id="staff_availability_title" />
            </h2>
          </div>
          <div className="dashboarcard">
            <form onSubmit={handleSubmitData}>
              <div className="WOrkDay table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>
                        <FormattedMessage id="operational_days_of_salon" />*
                      </th>
                      <th>
                        <FormattedMessage id="operational_hours_of_salon" />*
                      </th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {calendar?.length > 0 &&
                      calendar.map((item: any, index: any) => {
                        // item.end_time != "00:00:00" ? item.end_time : null
                        return (
                          <tr key={index}>
                            <td>
                              <div className="form-check ps-0">
                                <input
                                  className="form-check-input"
                                  id={`flexCheckDefault${index}`}
                                  type="checkbox"
                                  checked={item.is_day_off}
                                  onChange={(e: any) => {
                                    handleCheckboxChange(
                                      index,
                                      "start_time",
                                      "end_time",
                                      item.error,
                                    );
                                    setCalendarError("");
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`flexCheckDefault${index}`}
                                >
                                  <FormattedMessage
                                    id={
                                      albanianToEnglishDaysMap[item.day] ||
                                      item.day
                                    }
                                  />
                                  {/* item.day */}
                                </label>
                              </div>
                            </td>
                            <td>
                              <div className="row normalINput">
                                <div className="col-6">
                                  <DatePicker
                                    className="form-control"
                                    selected={
                                      isValidPickerDate(item.start_time)
                                        ? item.start_time
                                        : null
                                    }
                                    onChange={(date: any) => {
                                      handleInputFieldChange(
                                        index,
                                        "start_time",
                                        date,
                                      );
                                      setCalendarError("");
                                    }}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={5}
                                    timeCaption="Time"
                                    dateFormat="HH:mm"
                                    timeFormat="HH:mm"
                                    placeholderText="00:00"
                                  />

                                  <p className="text-danger">
                                    {item.error.start_time}
                                  </p>
                                </div>
                                <div className="col-6">
                                  <DatePicker
                                    selected={
                                      isValidPickerDate(item.end_time)
                                        ? item.end_time
                                        : null
                                    }
                                    className="form-control"
                                    onChange={(time: any) => {
                                      handleInputFieldChange(
                                        index,
                                        "end_time",
                                        time,
                                      );
                                      setCalendarError("");
                                    }}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={5}
                                    timeCaption="Time"
                                    dateFormat="HH:mm"
                                    timeFormat="HH:mm"
                                    placeholderText="00:00"
                                  />

                                  <p className="text-danger">
                                    {item.error.end_time}
                                  </p>
                                </div>
                              </div>
                            </td>
                            {index === 0 && (
                              <td>
                                <button
                                  type="button"
                                  className="applyAll"
                                  onClick={handleToClickAll}
                                >
                                  <FormattedMessage id="apply_for_all" />
                                </button>
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    {calendarError && (
                      <tr>
                        <td className="text-danger">{calendarError}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <Button
                text={(<FormattedMessage id="Save" />) as any}
                type="submit"
                className="btn btn-fill min-180"
                isLoading={salon_availability_update?.loading}
              />
            </form>

            {/*  ********************** Block Service Data ********************** */}

            {/* <BlockService /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default StaffAvailability;
